/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Meta_DescriptionInputs */

const en_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Alchema: AI-powered career tools for European job seekers. Founded 2026 in Germany by EliteX GbR. EU data processing — see /privacy for current details.`)
};

const de_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ueber Alchema: KI-gestuetzte Karriere-Tools fuer europaeische Jobsuchende. Gegruendet 2026 in Deutschland von EliteX GbR. Datenschutzdetails unter /privacy.`)
};

const fr_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos d'Alchema : outils de carrière alimentés par l'IA pour les chercheurs d'emploi européens. Fondée en 2026 en Allemagne.`)
};

const es_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre Alchema: herramientas de carrera impulsadas por IA para buscadores de empleo europeos. Fundada en 2026 en Alemania por EliteX GbR.`)
};

const it_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni su Alchema: strumenti di carriera basati sull'IA per chi cerca lavoro in Europa. Fondata nel 2026 in Germania da EliteX GbR.`)
};

const nl_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over Alchema: AI-aangedreven carrièretools voor Europese werkzoekenden. Opgericht in 2026 in Duitsland door EliteX GbR.`)
};

const pl_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Alchema: narzedzia kariery oparte na AI dla europejskich osob szukajacych pracy. Zalozona w 2026 w Niemczech przez EliteX GbR.`)
};

const fi_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa Alchemasta: AI-pohjaiset uratyökalut eurooppalaisille työnhakijoille. Perustettu 2026 Saksassa, EliteX GbR.`)
};

const da_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Alchema: AI-drevne karrierevaerktajer for europaeiske jobsogere. Grundlagt 2026 i Tyskland af EliteX GbR.`)
};

const sv_about_meta_description = /** @type {(inputs: About_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om Alchema: AI-drivna karriarverktyg for europeiska jobbsokare. Grundat 2026 i Tyskland av EliteX GbR.`)
};

/**
* | output |
* | --- |
* | "About Alchema: AI-powered career tools for European job seekers. Founded 2026 in Germany by EliteX GbR. EU data processing — see /privacy for current details." |
*
* @param {About_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_meta_description = /** @type {((inputs?: About_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Meta_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_meta_description(inputs)
	if (locale === "fr") return fr_about_meta_description(inputs)
	if (locale === "es") return es_about_meta_description(inputs)
	if (locale === "it") return it_about_meta_description(inputs)
	if (locale === "nl") return nl_about_meta_description(inputs)
	if (locale === "pl") return pl_about_meta_description(inputs)
	if (locale === "fi") return fi_about_meta_description(inputs)
	if (locale === "da") return da_about_meta_description(inputs)
	if (locale === "sv") return sv_about_meta_description(inputs)
	return en_about_meta_description(inputs)
});